import React from 'react';
import { useT } from '../i18n';

interface LeaderboardProps {
    // Both props are intentionally optional and ignored during the custodial
    // cutover (CF-CUSTODIAL-PIVOT-V1-R7E-1). They remain in the signature so
    // App.tsx imports compile without churn while the surface is hidden.
    apiBase?: string;
    onVerify?: (flipRequestId: string) => void;
}

/**
 * CF-CUSTODIAL-PIVOT-V1-R7E-1: Leaderboard + Live Flips surface hidden during
 * the Standard custodial cutover. The legacy implementation fetched
 * /api/leaderboard and /api/flips?limit=20 directly — both will be re-grounded
 * on the custodial ledger source of truth before this surface returns.
 *
 * Keeping the export signature stable so App.tsx routing is unchanged. The
 * placeholder card is the only render path; no network calls; no state.
 */
export function Leaderboard(_props: LeaderboardProps) {
    const t = useT();
    return (
        <div className="pb-4">
            <div className="glass-gold rounded-2xl p-6 mt-6 text-center">
                <span className="text-4xl block mb-3" aria-hidden="true">🏆</span>
                <h2 className="text-lg font-black tracking-tight">{t('leaderboard.placeholder.title')}</h2>
                <p className="text-[12px] mt-3 leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
                    {t('leaderboard.placeholder.body')}
                </p>
                <div
                    className="inline-block rounded-full px-3 py-1 mt-4"
                    style={{ background: 'rgba(244, 213, 111, 0.08)', border: '1px solid rgba(244, 213, 111, 0.22)' }}
                >
                    <span className="text-[10px] font-bold uppercase tracking-wide" style={{ color: 'var(--gold)' }}>
                        {t('leaderboard.coming_back')}
                    </span>
                </div>
            </div>

            <div className="glass rounded-xl p-3 mt-5 flex items-center gap-3">
                <span className="text-xl" aria-hidden="true">⚖️</span>
                <div>
                    <p className="text-[11px] font-bold" style={{ color: 'var(--gold)' }}>
                        {t('leaderboard.equal_odds.title')}
                    </p>
                    <p className="text-[9px]" style={{ color: 'var(--text-muted)' }}>
                        {t('leaderboard.equal_odds.body')}
                    </p>
                </div>
            </div>
        </div>
    );
}
